/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Config from 'solis/design-2';

import Routes from 'solis/enum/route';

import Navigation from 'solis/navigation';
import PublicArgs from 'solis/navigation/public.args';

import Application from 'solis/application';

import Route from 'solis/route';
import Router from 'solis/router';

import Auth from 'solis/auth';
import AuthBarrier from 'solis/claude/layout/barrier';
import ColonyBarrier from 'solis/claude/layout/colony.barrier';
import BoardBarrier from 'solis/claude/layout/board.barrier';

import Preferences from 'solis/preferences';

import Time from 'solis/time';
import Theme from 'solis/theme';


export default () =>
(
  <Auth.Export>

    <Preferences.Export>
      <Navigation.Export publicArgs = {PublicArgs}>

        <Route.Export route = {Navigation(client => client.route)} routes = {Routes}>

          <Application.Export currentUser = {Preferences(state => state.currentUser)}>

            <Theme.Export>
              <Time.Export application = {Application}>

                <AuthBarrier>
                  <ColonyBarrier>
                    <BoardBarrier>
                      <Router config = {Config} />
                    </BoardBarrier>
                  </ColonyBarrier>
                </AuthBarrier>

              </Time.Export>
            </Theme.Export>

          </Application.Export>

        </Route.Export>

      </Navigation.Export>
    </Preferences.Export>

  </Auth.Export>
);
